import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import AddJob from "./pages/AddJob";
import EditJob from "./pages/EditJob";

function App() {
    return (
        <Router>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/add" element={<AddJob />} />
                    <Route path="/edit/:jobId" element={<EditJob />} />
                </Routes>
                <ToastContainer position="top-center" />
            </Layout>
        </Router>
    );
}

export default App;
